import {
  Box,
  Typography,
  FormControlLabel,
  TextField,
  Paper,
} from "@mui/material";
import { locationServicesField, locationServicesPaperBox } from "../styles";
import { useTranslation } from "react-i18next";
import CustomCheckboxLabel from "../../../../../Components/CustomCheckboxLabel";
import AddressMapInput from "../../../../../Components/AddressMapInput";

const LocationSettingsContent = ({ formik }) => {
  const { t } = useTranslation(["price-services-steps", "categories"]);

  const {
    values: {
      pricelist: {
        subcategory_name,
        location: {
          business_address_enabled,
          business_address,
          service_areas_enabled,
          service_areas = [],
          online_enabled,
        },
      },
    },
  } = formik;

  const handleOptionChange = (option) => {
    formik.setFieldValue(
      `pricelist.location.${option}_enabled`,
      !formik.values.pricelist.location[`${option}_enabled`]
    );
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Box>
        <Typography fontSize="19px" fontWeight={500} color="#2F2B3D">
          {t("location_services_title")}
        </Typography>
        <Typography fontSize="14px" color="#2F2B3DB2">
          {t("location_services_description", {
            subcategory: subcategory_name,
          })}
        </Typography>
      </Box>

      <Paper variant="outlined" sx={locationServicesPaperBox}>
        <FormControlLabel
          control={
            <CustomCheckboxLabel
              checked={business_address_enabled}
              onChange={() => handleOptionChange("business_address")}
            />
          }
          label={
            <Box sx={{ ml: "7px" }}>
              <Typography fontWeight={600} fontSize={16} color="#2F2B3D">
                {t("business_address")}
              </Typography>
              <Typography fontSize="14px" color="#2F2B3DB2">
                {t("business_address_description")}
              </Typography>
            </Box>
          }
          sx={{ margin: "0px" }}
        />

        <Box sx={{ maxWidth: "528px" }}>
          <AddressMapInput
            placeholder={t("business_address_placeholder")}
            value={
              typeof business_address === "object"
                ? business_address?.address
                : business_address
            }
            onPlaceSelected={(placeDetails) => {
              formik.setFieldValue(
                "pricelist.location.business_address",
                placeDetails
              );
              formik.setFieldTouched(
                "pricelist.location.business_address",
                false
              );
            }}
          />
        </Box>
      </Paper>

      <Paper variant="outlined" sx={locationServicesPaperBox}>
        <FormControlLabel
          control={
            <CustomCheckboxLabel
              checked={service_areas_enabled}
              onChange={() => handleOptionChange("service_areas")}
            />
          }
          label={
            <Box sx={{ ml: "7px" }}>
              <Typography fontWeight={600} fontSize={16} color="#2F2B3D">
                {t("service_areas")}
              </Typography>
              <Typography fontSize="14px" color="#2F2B3DB2">
                {t("service_areas_description")}
              </Typography>
            </Box>
          }
          sx={{ margin: "0px" }}
        />
        <TextField
          fullWidth
          multiline
          size="small"
          disabled
          value={
            service_areas.length
              ? service_areas.map((a) => t(a, { ns: "districts" })).join(", ")
              : ""
          }
          placeholder={t("service_areas_placeholder")}
          sx={{
            ...locationServicesField,
            "& .MuiInputBase-root": {
              pointerEvents: "none",
              "&:hover": {
                borderColor: "none !important",
                boxShadow: "none !important",
              },
            },
            "& .MuiInputBase-input::placeholder": {
              opacity: 1,
            },
          }}
        />
      </Paper>

      <Paper variant="outlined" sx={locationServicesPaperBox}>
        <FormControlLabel
          sx={{ margin: "0px" }}
          control={
            <CustomCheckboxLabel
              checked={online_enabled}
              onChange={() => handleOptionChange("online")}
            />
          }
          label={
            <Box sx={{ ml: "7px" }}>
              <Typography fontWeight={600} fontSize={16} color="#2F2B3D">
                {t("online")}
              </Typography>
              <Typography fontSize="14px" color="#2F2B3DB2">
                {t("online_description")}
              </Typography>
            </Box>
          }
        />
      </Paper>
    </Box>
  );
};

export default LocationSettingsContent;
